<template>
    <div>
        <div class="formLabel mb1"><b>{{heading}}</b></div>
        <div><slot></slot></div>
    </div>
</template>

<script>
export default {
    props: {
        heading: {
            type: String,
            required: true
        }
    }
};
</script>
